import { useQuery } from '@tanstack/react-query';
import Api from '../helpers/Api';

type UseQrCodeParams = {
  language: string;
  locationId?: string;
  serviceId?: string;
  preferredLang?: string;
  preferredStaffId?: string;
  walkIn?: boolean;
};

export const makeUseQrCodeKey = (selections: UseQrCodeParams) => [
  `language:${selections.language}`,
  `location_id:${selections.locationId}`,
  `service_id:${selections.serviceId}`,
  `preferred_lang:${selections.preferredLang}`,
  `preferred_staff_id:${selections.preferredStaffId}`,
  `walk_in:${selections.walkIn}`,
];

export function useQrCode(selections: UseQrCodeParams) {
  const fetchQrCode = async () => {
    return Api.qrCode().generate(selections);
  };

  return useQuery({
    enabled: !!selections.locationId && !!selections.language,
    staleTime: 1000 * 60 * 60, // 60 minutes
    queryKey: makeUseQrCodeKey(selections),
    queryFn: fetchQrCode,
  });
}
